export const INVOICE_PAYMENT_METHOD_FILTERS = [
  'cash',
  'card',
  'mixed',
  'invoice',
  'bank_transfer',
  'mobile_pay',
  'online',
] as const;

export type InvoicePaymentMethodFilter = (typeof INVOICE_PAYMENT_METHOD_FILTERS)[number];

const METHOD_ORDER = ['cash', 'card', 'bank_transfer', 'invoice', 'mobile_pay', 'online'] as const;

function sortPaymentMethods(methods: string[]): string[] {
  const unique = [...new Set(methods.filter((method) => method !== 'reversal'))];
  return unique.sort((a, b) => {
    const orderA = (METHOD_ORDER as readonly string[]).indexOf(a);
    const orderB = (METHOD_ORDER as readonly string[]).indexOf(b);
    const rankedA = orderA === -1 ? 99 : orderA;
    const rankedB = orderB === -1 ? 99 : orderB;
    return rankedA - rankedB || a.localeCompare(b);
  });
}

/**
 * Keys for the invoice list "Maksutapa" cell. Prefer the payment trail
 * (so cash+card checkout renders as two methods); fall back to the
 * denormalized invoices.paymentMethod, including `mixed`.
 */
export function invoicePaymentMethodKeys(item: {
  paymentMethod?: string | null;
  paymentMethods?: string[] | null;
}): string[] {
  const fromPayments = sortPaymentMethods(item.paymentMethods ?? []);
  if (fromPayments.length > 0) return fromPayments;
  if (item.paymentMethod) return [item.paymentMethod];
  return [];
}
